import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from '@tanstack/react-router';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import * as Sentry from '@sentry/react';
import { router } from './router';
import { I18nProvider } from './i18n';
import { initTheme } from './store/theme';
import './index.css';

// ANX-084: применяем сохранённую тему до первого рендера (без вспышки светлой
// темы у пользователя с выбранной тёмной). CSP панели запрещает inline-script,
// поэтому раннее применение — здесь, в первом же self-модуле.
initTheme();

const sentryDsn = import.meta.env.VITE_SENTRY_DSN;
if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    environment: import.meta.env.VITE_SENTRY_ENV ?? 'production',
    release: import.meta.env.VITE_GIT_SHA,
    tracesSampleRate: 0,
    integrations: [],
  });
}

const root = document.getElementById('root');
if (!root) throw new Error('No #root element in index.html');

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 30_000,
    },
  },
});

createRoot(root).render(
  <StrictMode>
    <I18nProvider>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </I18nProvider>
  </StrictMode>,
);
